module.exports = __webpack_public_path__ + "img/163.2b115273.jpg";